<template>
  <div class="bindingMobile" style="background-color: white;">
    <div>
      <div class="back-icon">
        <van-icon name="arrow-left" size="22px" @click.native="backgo" />
      </div>
      <div class="content custom_div">
        <h1>{{pageType ? '请填写注册信息' : '绑定您的手机号'}}</h1>
        <template>
          <van-cell-group>
            <p>手机号</p>
            <van-field v-model="Mobile" clearable placeholder="请输入手机号" :error-message="mobileMessage" error-message-align="right" @blur="mobileChange" v-scrolltop/>
          </van-cell-group>
        </template>
        <template v-if="IsRegister">
          <van-cell-group>
            <p>姓 名</p>
            <van-field v-model="Name" clearable placeholder="请输入姓名" v-scrolltop/>
          </van-cell-group>

          <!--<van-cell-group>-->
            <!--<p>身份证</p>-->
            <!--<van-field v-model="IDCard" clearable placeholder="请输入身份证" :error-message="idCardMessage" error-message-align="right" @blur="idCardChange" v-scrolltop/>-->
          <!--</van-cell-group>-->

          <van-cell-group>
            <p>学 号</p>
            <van-field v-model="StudentID" clearable placeholder="请输入学号" :error-message="StudentIDMessage" error-message-align="right" @blur="studentIDChange" v-scrolltop/>
          </van-cell-group>

          <van-cell-group>
            <p>性 别</p>
            <!--<van-field v-model="Sex" placeholder="请选择性别" disabled @click.native="select = !select"/>-->
            <van-radio-group v-model="Sex">
              <van-radio checked-color="#00d8a0" name="男">男</van-radio>
              <van-radio checked-color="#00d8a0" name="女">女</van-radio>
            </van-radio-group>
          </van-cell-group>

          <van-cell-group>
            <p>在读学历</p>
            <van-radio-group v-model="Education1">
              <van-radio v-for="(item, index) in EducationList1" :key="index" checked-color="#00d8a0" :name=item>{{item}}</van-radio>
            </van-radio-group>
          </van-cell-group>

          <van-cell-group>
            <p>当前年级</p>
            <van-radio-group v-model="Education2">
              <van-radio v-for="(item, index) in EducationList2" :key="index" checked-color="#00d8a0" :name=item>{{item}}</van-radio>
            </van-radio-group>
          </van-cell-group>

          <van-cell-group>
            <p>地 址</p>
<!--            <van-field v-model="FullAddress" placeholder="请选择地址" disabled @click.native="editFullAddress" v-scrolltop/>-->
            <van-cell @click.native="editFullAddress">
              <span v-if="FullAddress">{{FullAddress}}</span>
              <span style="color: #C8C9CC" v-else>请选择地址</span>
            </van-cell>
          </van-cell-group>
        </template>

        <!--<van-popup v-model="select" position="bottom">-->
          <!--<van-picker title="性 别" show-toolbar @cancel="onCancel" @confirm="onConfirm" :columns="columns" @change="onChange" />-->
        <!--</van-popup>-->
        <van-button type="info" size="small" :loading="btnLoading" loading-text="正在提交..." @click="binding" style="background: #00d8a0!important;border: 1px solid #00d8a0!important;">{{!IsRegister ? '绑 定' : '注 册'}}</van-button>
        <!--<van-radio v-if="!IsRegister" checked-color="rgb(0,216,160)"><p @click="Onchange" style="text-decoration:underline;margin:0;">我同意《宁波大学学生宿舍空调租赁协议》</p></van-radio>-->
        <!--<van-popup v-model="show" style="width:100%;height: 100%;padding:20px;">-->
          <!--<p style="text-align: center;margin:5px 0;font-size: .5rem;font-weight: bold">宁波大学学生宿舍空调租赁协议</p><br/>-->
          <!--甲方(出租方) 	：宁波思沃信息科技有限公司<br/>-->
          <!--乙方(承租方)	：宿舍全体成员<br/>-->
          <!--为了明确出租方与承租方的权利义务，经双方充分协商制定本协议，以便共同遵守。<br/>-->
          <!--一、乙方向甲方租用品牌空调壹台。租赁选项：详见学生网页选择的租赁选项及费用标准。<br/>-->
          <!--1、每年9月1日至次年的8月31日为壹学年，租期不足一学年按一学年计费。<br/>-->
          <!--2、办理租赁时，需缴纳租赁选项中相应的租金和押金400元/台（含遥控器100元在内）。<br/>-->
          <!--二、甲方在校内设有空调服务点，实行常年定点定人服务。对于空调器本身质量原因引起的故障，实施免费修理。服务电话18857498585/555577。<br/>-->
          <!--三、甲方所提供的空调设备及相关辅件的所有权归甲方所有，乙方对所承租的空调设备及相关辅件没有买卖、转租的权力。乙方在未付清空调租赁费用期间，不得使用空调设备，甲方同时有权处置相应空调设备包括拆除空调设备。甲方对所出租的空调设备定期提供免费的维护保养，确保空调正常使用。甲方对突发性机组故障给予及时的检查维修服务，接到乙方报修电话后，24 小时内上门进行维修服务。<br/>-->
          <!--四、此协议为租赁协议，乙方只拥有租赁期内的使用权。根据乙方不同租赁期收取相应的租赁费，乙方不得中途退租，如有特殊原因，需与甲方另行协商，并承担甲方的相应损失，因校方调整宿舍除外。搬迁宿舍时双方需终止此协议。租赁期结束，乙方应保证空调器整机完整表面无破损，配辅件齐全。并将遥控器退还至空调服务点，经验收合格后办理移交手续。甲方退还乙方押金。乙方应在租赁到期前办理续租或退租，乙方未办理的按续租计费。<br/>-->
          <!--五、未尽事宜由双方协商解决。<br/>-->
          <!--六、本电子协议具有相同的法律效应。<br/>-->
          <!--七、甲方特别重申，乙方特别承诺：此协议为租赁协议，空调所有权归甲方，乙方不得将空调私自变卖、转租、移装、拆除，或请非甲方专业人员拆修。在任何情况下，乙方都不能带电私自或请非甲方专业人员拆修，否则所造成乙方或他人的一切财产及人身安全由乙方或私自拆修者承担全责。-->
          <!--<van-col :span="24" style="text-align: center;margin-top: 10px;">-->
            <!--<van-button type="info" @click="Onchange">我已阅读</van-button>-->
          <!--</van-col>-->
        <!--</van-popup>-->
      </div>
    </div>
    <van-popup v-model="addrVisible" style="width: 100%;height: 100%" get-container="body" position="right">
      <change-addr v-if="addrVisible" @close="addrVisible = false" @changeAddr="getNewAddr" is-popup></change-addr>
    </van-popup>
  </div>
</template>

<script>
import {
  setWeixInfo,
  removeWeixInfo
} from '@/utils/auth'
import changeAddr from "@/views/user/changeAddr/index.vue";
export default {
  name: 'bindingMobile',
  data () {
    return {
      addrVisible: false,
      StudentIDMessage: '',
      Education1:'',
      radio:'agree',
      Education2:'',
      EducationList1: ['大专','本科','研究生'],
      EducationList2: ['一年级','二年级','三年级','四年级'],
      EducationMessage1: '',
      EducationMessage2: '',
      IsRegister: false,
      FullAddress: '',
      IDCard:'',
      show:false,
      Mobile: '',
      Name: '',
      idCardMessage:'',
      StudentID: '',
      Sex: '',
      DormitoryId: '',
      columns: ['男', '女'],
      select: false,
      mobileMessage: '',
      btnLoading: false,
      backUrl: '',
      backQuery: {}
    }
  },
  computed: {
    pageType() {
      return this.IsRegister
    }
  },
  components: {changeAddr},
  methods: {
    getNewAddr(data){
      this.DormitoryId = data[data.length - 1].Id
      this.FullAddress = data.map(res => res.Name).join('-')
      this.addrVisible = false
    },
    Onchange(){
        this.show = !this.show
    },
    idCardChange(){
        if(!this.IDCard){
            this.idCardMessage = '请填入身份证号'
        }else if(!(/^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/.test(this.IDCard))){
            this.idCardMessage = '身份证号有误'
        }else{
            this.idCardMessage = ''
        }
    },
    studentIDChange() {
      if(this.StudentID && this.StudentID !== '') {
        this.StudentIDMessage = ''
      } else {
        this.StudentIDMessage = '请输入学号'
      }
    },
    editFullAddress() {
      this.addrVisible = true
      // this.$router.push({path: '/userIn/userAddress'})
    },
    onCancel(val) {
      this.select = !this.select
    },
    onConfirm(val) {
      this.Sex = val
      this.select = !this.select
    },
    onChange() {

    },
    backgo() {
      // this.$router.go(-1)
      this.$router.replace({name: this.backUrl, query: this.backQuery})
    },
    mobileChange() {
      if(this.Mobile !== '') {
        if (!(/^1[3456789]\d{9}$/.test(this.Mobile)))
          this.mobileMessage = '手机号码有误！'
        else
          this.mobileMessage = ''
      }
    },
    binding() {
      if(this.Mobile !== '' && this.mobileMessage !== '手机号码有误！')  {
        let params = {
          Mobile: this.Mobile
        }
        let url = '/BizMemberMember/Binding'
        if(this.IsRegister) {
          if(!this.Education1){
            this.$dialog.alert({
              message: '请选择在读学历'
            })
            return false
          }
          if(!this.Education2){
            this.$dialog.alert({
              message: '请选择当前年级'
            })
            return false
          }
          url = '/BizMemberMember/Edit'
          let model = {
            Name: this.Name,
            IDCard: this.IDCard,
            StudentID: this.StudentID,
            Education: this.Education1+'|'+this.Education2,
            Education1: this.Education1,
            Education2: this.Education2,
            Sex: this.Sex === '男' ? 1 : 0,
            DormitoryId: this.DormitoryId || undefined// 判断是否存在地址修改后的数组，如果有则从数组中取，如果没有，则从源数据中返回宿舍ID
          }
          params = Object.assign(params, model)
        }
        this.btnLoading = true
        this.$post(url, params).then(res => {
          this.btnLoading = false
          if(res.Status !== 1) {
            if(res.Message === '未找到手机号') {
              this.IsRegister = true
            }
            return false
          }
          removeWeixInfo()
          setWeixInfo(JSON.stringify(res.Data))
          this.$dialog.alert({
            message: res.Message
          }).then(() => {
            this.$router.push({path: '/user'})
          })
        })
      }
    },
    getDetailsByKey() {
      this.$post('/BizMemberMember/DetailsByKey').then(res => {
        if(res) {
          if(res.Data.IsRegister) {
            this.$router.push({path: '/user', replace: true})
          }
        }
      })

    }
  },
  mounted () {
    // this.IsRegister = this.$route.query.type === 'register'
    this.getDetailsByKey()
  },
  activated() {
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.backUrl = from.name === 'transfer' ? 'home' : from.name
      vm.backQuery = from.query
    })
  }
}
</script>

<style lang="less" scoped>
  .content {
    P{
      margin: 0;
      margin-top: 15px;
      color: #666;
      + div{
        padding-top: 5px;
      }
    }
  }
  /*.bindingTab{*/
    /*margin-bottom: 50px;*/
    /*ul{*/
      /*display: flex;*/
      /*justify-content: center;*/
      /*align-items: center;*/
      /*li{*/
        /*padding: 0 10px;*/
      /*}*/
      /*li:nth-child(1) {*/
        /*font-size: 16px;*/
        /*color: #00d8a0;*/
      /*}*/
    /*}*/
  /*}*/
  .bindingMobile{
    padding-top: 50px;
    >div{
      position: absolute;
      top: 0;
      left: 0;
      background: #fff;
      height: 100%;
      width: 100%;
    }
    .back-icon{
      display: block;
      padding: 20px;
    }
    .content{
      width: 80%;
      margin: 0 auto;
      h1{
        margin-bottom: 30px;
        font-size: 22px;
        font-weight: normal;
      }
      .mobile-icon{
        margin-right: 6px;
      }
      button{
        width: 100%;
        margin: 20px 0;
        -webkit-border-radius: 200px;
        -moz-border-radius: 200px;
        border-radius: 200px;
      }
    }
    .van-radio-group{
      display: flex;
      flex-wrap: wrap;
      .van-radio{
        margin-right: 25px;
        margin-top:15px;
      }
      .van-radio:first-child{

      }
    }
  }
  .van-hairline--top-bottom::after{
    border: 0;
  }
  .van-field{
    border-bottom:1px solid #ebedf0;
  }
</style>
<style lang="less">
  .bindingMobile{
    .van-field__control:disabled{
      color: #323233;
    }
  }
</style>
